// extracted by mini-css-extract-plugin
export default {"quote":"quote_quote__7juP8","quoteFrase":"quote_quoteFrase__kePkT"};